export class BankModalModel {
  constructor() {
    this._content = null;
  }

  set content(content) {
    this._content = content;
  }
  
  get content() {
    return this._content;
  }
}

export default BankModalModel;



// WEBPACK FOOTER //
// ./client/app/pages/customer/deposit/model/bank-modal.model.js